import { Search, Filter, X, Calendar } from 'lucide-react';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';

interface UserSearchProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  userType: string;
  onUserTypeChange: (value: string) => void;
  joinedFrom: string;
  onJoinedFromChange: (value: string) => void;
  joinedTo: string;
  onJoinedToChange: (value: string) => void;
  onClearFilters: () => void;
}

export function UserSearch({
  searchTerm,
  onSearchChange,
  userType,
  onUserTypeChange,
  joinedFrom,
  onJoinedFromChange,
  joinedTo,
  onJoinedToChange,
  onClearFilters,
}: UserSearchProps) {
  const hasFilters = searchTerm || userType || joinedFrom || joinedTo;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex-1">
          <Input
            placeholder="Search by name or email..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            icon={<Search className="w-4 h-4" />}
          />
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <div className="relative">
            <Filter className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#64748b]" />
            <select
              value={userType}
              onChange={(e) => onUserTypeChange(e.target.value)}
              className="appearance-none bg-[#12121a] border border-[#2a2a3a] rounded-lg pl-10 pr-8 py-2 text-sm text-[#f8fafc] focus:outline-none focus:border-[#3b82f6] min-w-[140px]"
            >
              <option value="">All Types</option>
              <option value="company">Company</option>
              <option value="job_seeker">Job Seeker</option>
            </select>
          </div>

          {hasFilters && (
            <Button variant="ghost" size="sm" onClick={onClearFilters} icon={<X className="w-4 h-4" />}>
              Clear
            </Button>
          )}
        </div>
      </div>

      <div className="flex flex-wrap items-end gap-3">
        <div className="flex items-center gap-2 text-xs font-semibold text-[#94a3b8] uppercase tracking-wider shrink-0">
          <Calendar className="w-4 h-4" />
          <span>Joined</span>
        </div>
        <Input
          type="date"
          label="From"
          value={joinedFrom}
          onChange={(e) => onJoinedFromChange(e.target.value)}
          className="min-w-[160px] [color-scheme:dark]"
        />
        <Input
          type="date"
          label="To"
          value={joinedTo}
          min={joinedFrom || undefined}
          onChange={(e) => onJoinedToChange(e.target.value)}
          className="min-w-[160px] [color-scheme:dark]"
        />
      </div>
    </div>
  );
}
